import { useState } from "react";
import { Outlet } from "react-router-dom";

import { Box, Grid, makeStyles } from "@material-ui/core";

import { Header } from "../dashboard/Header";
import { COLORS } from "../../theme/colors";

const useStyles = makeStyles(() => ({
  box: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1,
    flexWrap: "nowrap",
    overflow: "auto",
  },
  gridContent: {
    flexGrow: 1,
    overflow: "auto",
    backgroundColor: COLORS.cultured,
  },
}));

export const BuildingsLayout = () => {
  const classes = useStyles();
  const [collapsed, setCollapsed] = useState(true);

  return (
    <Box className={classes.box}>
      <Header onHoverLogo={() => setCollapsed(!collapsed)} />
      <Grid container className={classes.content}>
        <Grid item className={classes.gridContent}>
          <Outlet />
        </Grid>
      </Grid>
    </Box>
  );
};
